// src/services/contractsApi.js
// Rotas alinhadas ao backend (contracts_simple.py)
import api from './api';

// ---------- Templates de Contratos ----------
export async function listContractTemplates() {
  const { data } = await api.get('/contracts/templates');
  return data?.items || data || [];
}

export async function createContractTemplate(payload) {
  // payload deve conter "template_name", "category" (string), etc.
  const { data } = await api.post('/contracts/templates', payload);
  return data;
}

export async function updateContractTemplate(id, payload) {
  const { data } = await api.put(`/contracts/templates/${id}`, payload);
  return data;
}

export async function deleteContractTemplate(id) {
  const { data } = await api.delete(`/contracts/templates/${id}`);
  return data;
}

// ---------- Contratos (documents) ----------
export async function listContracts(params) {
  let url = '/contracts/documents';

  if (params && typeof params === 'object') {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.append(key, value);
      }
    });
    const qs = search.toString();
    if (qs) url += `?${qs}`;
  }

  const { data } = await api.get(url);
  return data?.items || data || [];
}

export async function createContract(payload) {
  const { data } = await api.post('/contracts/documents', payload);
  return data;
}

export async function updateContract(id, payload) {
  const { data } = await api.put(`/contracts/documents/${id}`, payload);
  return data;
}

export async function deleteContract(id) {
  const { data } = await api.delete(`/contracts/documents/${id}`);
  return data;
}

// ---------- Histórico ----------
export async function getContractsHistory(limit = 50, offset = 0) {
  const { data } = await api.get(`/contracts/history?limit=${limit}&offset=${offset}`);
  return data?.documents || data || [];
}

// ---------- Auxiliares ----------
export async function listPatients(limit = 100) {
  const { data } = await api.get(`/patients?limit=${limit}`);
  return data?.items || data || [];
}

// Branding (compartilhado com Receituários)
// Branding (compartilhado com Receituários)
export async function getBranding(professionalId = null) {
  let url = '/prescriptions/branding';
  if (professionalId) {
    url += `?professional_id=${professionalId}`;
  }
  const { data } = await api.get(url);
  return data || null;
}

// Envio por e-mail (mesmo endpoint usado em Receituários)
export async function sendContractEmail(payload) {
  // backend expõe /documents/send-email e /api/documents/send-email
  const { data } = await api.post('/documents/send-email', payload);
  return data;
}

// ---------- Assinatura Digital ----------
// Cria um link público para o paciente assinar (token + URL)
export async function createContractSignLink(documentId) {
  const { data } = await api.post(`/contracts/documents/${documentId}/sign-link`);
  return data; // { token, sign_url, expires_at }
}

// (usado pela página pública) – carrega dados do documento para assinatura
export async function getPublicContractForSign(token) {
  const { data } = await api.get(`/public/contracts/sign/${token}`);
  return data; // { document, branding, request }
}

// (usado pela página pública) – envia a assinatura do paciente
export async function submitPublicContractSign(token, payload) {
  const { data } = await api.post(`/public/contracts/sign/${token}`, payload);
  return data; // { message, validation_code, document_id }
}

// Retorna assinaturas do documento (latest=true pega a mais recente primeiro)
export async function getContractSignatures(documentId, latest = false) {
  const { data } = await api.get(`/contracts/documents/${documentId}/signatures?latest=${latest ? 1 : 0}`);
  return Array.isArray(data) ? data : [];
}
